 $(".change-quantity-main").change(function(){
    var quantity = $(this).val();
    var varient = this.id;
    var data = { updates: {} };
    data.updates[varient] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
        location.reload();
      }
    });
  });

var buttonPlus  = $(".js-change-quantity-plus");
var buttonMinus = $(".js-change-quantity-minus");

var incrementPlus = buttonPlus.click(function() {
  var $n = $(this)
  .parent(".product-quantity-box")
  .find(".quantity-number");
  $n.val(Number($n.val())+1 );
  $('.change-quantity-main').trigger('change');
});

var incrementMinus = buttonMinus.click(function() {
  var $n = $(this)
  .parent(".product-quantity-box")
  .find(".quantity-number");
  var amount = Number($n.val());
  if (amount > 0) {
    $n.val(amount-1);
  }
  $('.change-quantity-main').trigger('change');
});

// ----------------------Read more ------------------------------------------
 $('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.seo-full-schema');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.seo-short-schema');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.seo-full-schema');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.seo-short-schema');
  descriptionShort.style.display = 'block';
});  
// ----------------------End Read more ------------------------------------------
// -------------------------collection toggle----------------------------------------
$('.collection-grids').click(function() {
    $('.ul-product > li').addClass('grid__item');
    $('.ul-product > li').removeClass("list__item");
});
$('.collection-lists').click(function() {
    $('.ul-product > li').addClass("list__item");
    $('.ul-product > li').removeClass("grid__item");
});
// -------------------------End collection toggle----------------------------------------
// -------------------------hover menu-------------------------------
$(".mega-menu").hover(function(){
   $(this).attr('open','');
  }, function(){
  $(this).removeAttr('open');
});
// -------------------------end menu---------------
jQuery(document).ready(function($) {
  $('.mobile-slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
});
$(document).ready(function (){
  // Delete that line if you don't want the first Div to be displayed by default
  // $(".section-hidden").css("display", "none");
  $(".section-hidden:not(:first-of-type)").css("display", "none");
  // 
  $("h3").click(function () {
    $(this).next().slideToggle(500);
    $(".section-hidden").not($(this).next()).slideUp(500);
    
    // how to rotate the icon JUST h3>i
    // $("i").css({'transform':'rotate(180deg)'});
    
  });
});